export default __webpack_public_path__ + "static/media/mon_256.2feb0fa5.png";